<template>
  <div class="pb-16">
    <!-- 본문 -->
    <v-sheet class="pt-4 mx-auto">
      <div class="sela caption2 px-10 px-md-16 py-4" style="text-align: center; color: rgb(83, 83, 83)">
        선택 기한(7일)이 지나면 원본 사진은 삭제되므로 미리 다운로드하시기를 권장합니다. 선택 기간 안에서는 얼마든지 추가로 최종 완성 요청을 더 하실 수 있습니다
      </div>

      <!-- 촬영 내역 없을 시 -->
      <v-sheet v-if="!list.length" class="rounded-10 pt-8 text-center text-subtitle-1 primary--text">
        <v-icon size="40" color="primary" class="mb-2">mdi-cancel</v-icon><br />
        촬영 내역이 없습니다
      </v-sheet>

      <!-- 촬영 내역 있을 시 -->
      <v-sheet v-if="list.length" class="rounded-5 px-2 text-subtitle-1 primary--text">
        <ShotCard v-for="item in list" :key="item.id" :item="item" />
      </v-sheet>
    </v-sheet>
  </div>
</template>
<script>
import ShotCard from "./ShotCard"

export default {
  components: {
    ShotCard,
  },
  data: () => ({
    list: [],

    selected_list: [],

    dialog: {
      download: false,
    },
  }),

  mounted() {
    this.load()
  },

  methods: {
    load() {
      this.$http
        .post("/api/qrcode/select/byUser", {
          params: {
            user_id: this.$store.state.lafia_user.user_id,
          },
        })
        .then((res) => {
          console.log(res)
          this.list = res.data.reverse()
        })
    },
  },
}
</script>
